import "@fontsource/inter";
import "@fontsource/inter/400.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import "@fontsource/poppins";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/400-italic.css";

export const AllTypoFontStyles = {
  CommonCardsTitleTypo: {
    fontSize: 16,
    fontWeight: 600,

  },
  CommonCardsValueTypo: {
    fontSize: {
      xs: "1rem",
      md: "1.8rem",
    },
    fontWeight: 500,

  },
  CommonTypo0: {
    fontSize: 16,
    fontWeight: 600,

  },
  CommonTypo1: {
    whiteSpace: "nowrap",
    fontSize: 16,
    fontWeight: 500,

  },
  CommonTypo2: {
    fontSize: 14,
    fontWeight: 400,

  },
  CommonTypo3: {
    fontSize: 14.93,
    fontWeight: 400,
    fontFamily: "roboto",
  },
  CommonTypo4: {
    fontSize: 16,
    fontWeight: 700,

  },
  QtyTypo: {
    pt: 1,
    pr: 1,
    fontSize: 12,
    fontWeight: 400,

  },
  ExportBtnTypo: {
    fontSize: 14,
    fontWeight: 600,

    mt: 0.2,
    color: "#0C7238",
  },
};

export const adminDashboardStyles = {
  AdminDashboardMainBox: {
    flexGrow: 1,
    padding: 2,
    backgroundColor: "#F6F7F9",
  },
  AdminDashboardPaper: {
    borderRadius: 3,
    padding: 1.5,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: 125
  },
  AdminDashboardTitleTypo: {
    mb: 1,
    fontSize: 16,
  },
  AdminDashboardBox1: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  AdminDashboardChartGrid: {
    display: "flex",
    justifyContent: "space-around",
  },
  AdminDashboardChartPaper: {
    padding: 2,
    textAlign: "center",
    height: 258,
    width: "48%",
    borderRadius: 3,
  },
  AdminDashboardChartBox: {
    display: "flex",
    justifyContent: "center",
  },
  AdminDashboardCalender: {
    height: 700,
    fontSize: 16,
    fontWeight: 600,

  },
};

export const userDashboardStyles = {
  AdminDashboardMainBox: {
    flexGrow: 1,
    padding: 2,
    backgroundColor: "#061F44",
  },
  AdminDashboardPaper: {
    borderRadius: 3,
    padding: 1.5,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  AdminDashboardTitleTypo: {
    mb: 1,
    fontSize: 16,
  },
  AdminDashboardBox1: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  AdminDashboardChartGrid: {
    display: "flex",
    justifyContent: "space-around",
  },
  AdminDashboardChartPaper: {
    padding: 2,
    textAlign: "center",
    height: 250,
    width: "48%",
    borderRadius: 3,
  },
  AdminDashboardChartBox: {
    display: "flex",
    justifyContent: "center",
  },
  AdminDashboardCalender: {
    height: 700,
    fontSize: 16,
    fontWeight: 600,

  },
};

export const EventManagementStyles = {
  EventTypo1: {
    whiteSpace: "nowrap",
    fontSize: 16,
    fontWeight: 500,

  },
  Box1: {
    gap: 2,
    alignItems: "center",

    display: "flex",
    // flexDirection: { xs: "column" , lg: "row" },
    flexDirection: { xs: "column" , sm: "row", md: "column", lg: "row", xl: "row" },
    justifyContent: { xs: "center", md: "space-between" },
    width: '100%',
    "& > *": { width: "100%" },
  },

  Box2: {
    fontSize: 14,
    fontWeight: 700,

    display: "flex",
    flexDirection: { lg: "row", xs: "column" },
    justifyContent: { md: "space-between", xs: "center" },

  },
  Box3: {
    width: "100%",
    fontSize: 14,
    fontWeight: 400,

    width: '100%'
  },
  SearchField: {
    "& .ant-input::placeholder": {
      color: "black",
    },
    color: "black",
    width: '100%',
    marginLeft: 1,
    "& .MuiInputBase-input": {
      height: "1px",
    },

    "& .MuiInputLabel-root": {
      transform: "translate(0, 1.5px) scale(0.75)",
    },
    "& .MuiInputBase-root": {
      marginBottom: "8px",
    },
  },
  AddEventBtn: {

    fontWeight: 600,
    color: "#2E728F",
    fontSize: 14,
    // mb: 2,
  },
  Bookbtn: {
    ml: 1,
    backgroundColor: "#061F44",
  },
  IconColor: { color: "#2E728F" },
};

export const addEventMainStyles = {
  UploadPicIconContainer: {
    position: "relative",
    cursor: "pointer",
    border: "1px dashed #ccc",
    borderRadius: "4px",
    overflow: "hidden",
    width: "100%",
    height: "auto",
    padding: "10px",
  },
  UploadPicSilverTypo: {
    marginTop: "10px",
    color: "#555",
    fontSize: "14px",
  },
  MainContainerGrid: {

  },
  GridWrap: {
    whiteSpace: "wrap",
  },
  StepsContainer: {
    fontSize: 17,
    fontWeight: 700,
    fontFamily: "roboto",
    justifyContent: "center",
  },
  StepsCompleteBox: {
    mt: 1,
  },
  StepsBtnBox: {
    justifyContent: 'end',
    position: { md: "fixed", xs: "relative" },
    bottom: "0px",
    right: { md: "16px", xs: "-16px" },
    display: "flex",
    mr: 0,
    p:1,
    pr:2,
    gap: "8px",
    left: { md: "16px", xs: "0px" },
    zIndex: 10
  },
  AddEventFieldTypo: {

    fontSize: "14px",
    fontWeight: 600,
  },
  MainPaper: {
    padding: 2,
    height: { xl: "100vh", lg: "100vh", md: "100vh", sm: "100%", xs: "100%" },
  },
  StepperContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  StepsBox: {
    mt: 1,
    mb: 1,
  },
  BtnsBox: {
    display: "flex",
    justifyContent: "flex-end",
  },
  BkBtnStyles: {
    mt: { md: 1, xs: 5 },
    ml: 1,
    border: "1px solid #2E728F",
    color: "#061F44",
    borderRadius: '4px',
    width: { md: 120, sm: 200, xs: 200 },
    height: 35,
  },
  NextBtnStyles: {
    backgroundColor: "var(--secondary-color)",
    color: "white",
    mt: { md: 1, xs: 5 },
    mr:3,
    ml: 1,
    borderRadius: '4px',
    width: 200,
    height: 35,
    "&:hover": {
      backgroundColor: "var(--primary-color)",
    },
  },
  UploadPicContainer: {
    justifyContent: "center",
    display: "flex",

  },
  UploadPicGrid: {
    border: "2px dashed silver",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 5,
    mb: 2,
    backgroundColor: "#EDF2F6",
    // width: { md: "228px", sm: "100%", xs: "100%" },
    minHeight: { md: "218px", sm: "100%", xs: "100%" },
    overflow: "hidden",
    mt: 2,
  },
  UploadPicIconContainer: {
    justifyContent: "center",
    display: "flex"
  },
  UploadPhotoIcn: {
    color: "silver",
    fontSize: 50,
  },
  UploadPicSilverTypo: {
    color: "silver",
    fontSize: 14,
    fontWeight: 400,

    whiteSpace: "nowrap",
  },
  UploadPicBox2: {
    justifyContent: "center",
    display: "flex",
    cursor: "pointer",
  },
  UploadBlueTypo: {
    color: "dodgerblue",
    fontSize: 11,
  },
  DateTimeFieldWidth: {
    width: "429px",
    height: "47px",
  },
};

export const SideDrawerStyles = {
  SideDrawerBox1: {
    marginTop: { xs: 5, sm: 0, md: 0, lg: 0, xl: 0 },
    padding: "12px",
    borderRadius: "10px",
    backgroundColor: "var(--primary-color)",
    color: "#fff",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

  },
  SideDrawerBox2: {
    justifyContent: "center",
    alignItems: "center",

    paddingLeft: "10px",
    paddingTop: { md: 3, sm: 5, xs: 0 },
  },
  ListIcns: { color: "#fff", },
  DividerStyles: {

    backgroundColor: "white",
  },
};

export const TopBarStyles = {
  AppBar: {

    width: { sm: `calc(100% - ${318}px)` },
    ml: { sm: `${318}px` },
    backgroundColor: "#fff",
    color: "#000",
    boxShadow: "none",
    borderBottom: "1px solid #e0e0e0",
  },
  IcnBtn: {
    mr: 2,
    display: { sm: "none" },
  },
};

export const MainLayoutStyles = {
  DrawerBox1: { display: "flex", },
  DrawerBox2: {
    width: { sm: 250 },
    flexShrink: { sm: 0 },

  },
  DrawerBox3: {
    bgcolor: "#F6F7F9",
    width: "100%",
    height: "100%",

  },
  LargeMediumDrawer: {
    display: { xs: "none", sm: "block" },
    "& .MuiDrawer-paper": {
      boxSizing: "border-box",
      width: 250,
      padding: "5px 5px 5px 5px",
      borderRadius: "10px",
      backgroundColor: "#061F44",
      color: "#fff",
      margin: "5px 0px 10px 10px",
      height: "calc(100% - 10px)",

    },
  },
  MobileDrawer: {
    display: { xs: "block", md: "none" },
    "& .MuiDrawer-paper": {
      boxSizing: "border-box",
      width: '90%',
      maxWidth: 300,
      padding: "15px",
      borderRadius: "10px",
      backgroundColor: "var(--primary-color)",
      color: "#fff",
      height: "100%",

    },
  },
};

export const SettingsStyles = {
  ResetBtnStyles: {
    whiteSpace: "nowrap",
    ml: 1,
    border: "1px solid #2C6D88",
    color: "#2C6D88",
    borderRadius: '4px',
    width: { md: 150, sm: 200, xs: 200 },
    height: 35,

  },
  UpdateBtnStyles: {
    backgroundColor: "var(--secondary-color)",
    "&:hover": {
      backgroundColor: "var(--primary-color)",
    },
    color: "white",
    ml: 1,
    borderRadius: '4px',
    width: 200,
    height: 35,

  },
};

export const OrLineStyles = {
  OrBox: {
    display: "flex",
    flexDirection: "row",
    marginTop: {
      lg: "1.5rem",
      md: "1.5rem",
      sm: "1.5rem",
      xs: "2rem",
    },
  },
  Line: {
    width: "100%",
    border: 0,
    height: "2px",
    backgroundColor: "black",
  },

  OrText: {
    color: "#202227",
    fontFamily: "Arial Rounded MT, sans-serif",
    fontSize: {
      lg: "0.875rem",
      md: "0.875rem",
      sm: "0.875rem",
      xs: "0.875rem",
    },
    fontWeight: 400,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    whiteSpace: "nowrap",
    padding: "0 10px",
  },
};
